import { groupLogo } from "../../constants/constants";
import AvatarCard from "../avatar-card";
import Badge from "../badge";
import Label from "../label";

interface GroupSpotlightPreviewProps {
    recognitionFor?: string[];
    description?: any;
    nomineeUser?: any;
    file?: any;
    projects?: any[];
    members?: any[];
    nominationType?: string;
}

export function GroupSpotlightPreview({ recognitionFor, description, nomineeUser, file, projects, nominationType, members }: GroupSpotlightPreviewProps) {
    return (
        <div>
            <div className="border border-feildBorder rounded-cardRadius mb-1 px-5 py-3.5 bg-white !w-[100%] max-w-[85rem]">
                <div>
                    <AvatarCard
                        imageUrl={file?.name ? URL.createObjectURL(file) : projects?.[0]?.project?.logo_url ? projects?.[0]?.project?.logo_url : groupLogo}
                        title={projects?.[0]?.project?.name || "Group Spotlight"}
                        size="md"
                        titleClassName="font-aeonikReg !text-[20px] leading-normal"
                        isViewMore={false}
                    />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 mt-2">
                    {nominationType === "project" ?
                        Array.isArray(members) && members.map((item: any) => (
                            <div key={item?.id}
                                className="border border-gray-300 rounded-lg p-1"
                            >
                                <AvatarCard
                                    imageUrl={item?.personal_image}
                                    title={item?.name}
                                    subTitle={item?.job_title}
                                    size="xs"
                                    avatarClassName="avatarCardDiv"
                                    isViewMore={false}
                                />
                            </div>
                        ))
                        :
                        Array.isArray(nomineeUser) && nomineeUser.map((item: any) => (
                            <div key={item?.id}
                                className="border border-gray-300 rounded-lg p-1"
                            >
                                <AvatarCard
                                    imageUrl={item?.personal_image}
                                    title={item?.name}
                                    subTitle={item?.job_title}
                                    size="xs"
                                    avatarClassName="avatarCardDiv"
                                    isViewMore={false}
                                />
                            </div>
                        ))

                    }
                </div>
                <div className="flex flex-row items-start !gap-4 !mt-2 !mb-3">
                    {/* Recognized For Section */}
                    {/* <div className="flex flex-col w-full">
                        {recognitionFor && Array.isArray(recognitionFor) && recognitionFor.length > 0 ? (
                            <>
                                <Label
                                    label="Recognized For"
                                    className="text-labelTextCol !text-[14px] !font-aeonikBold"
                                />
                                <div className="flex gap-1 w-full flex-wrap text-sm font-medium">
                                    {recognitionFor.map((item: any, index: number) => (
                                        <Badge
                                            key={index}
                                            name={item?.recognition?.title || (typeof item === 'string' ? item : 'Unnamed Recognition')}
                                            className="!p-1.5"
                                        />
                                    ))}
                                </div>
                            </>
                        ) : (
                            <p className="text-gray-400 mt-2">No recognitions available.</p>
                        )}
                    </div> */}


                    {recognitionFor && Array.isArray(recognitionFor) ? (
                                            recognitionFor?.length > 0 ? (
                                                <div>
                                                    <Label label="Recognized For" className="text-labelTextCol !text-base !font-aeonikReg !text-sm" />
                                                    <div className="flex flex-wrap gap-2 text-sm font-medium">
                    
                                                        {recognitionFor.map((item: any, index: number) => (
                                                            <div
                                                                key={index}
                                                                className="text-xs font-aeonikReg border border-black rounded-basicRadius px-2 py-1 break-words whitespace-normal max-w-[200px]"
                                                            >
                                                                <span className="block">{item?.recognition?.title}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ) : (
                                                <p className="text-gray-400 mt-2">No recognitions available.</p>
                                            )
                                        ) : null}
                </div>

                {/* Descripton */}
                <div>
                    <Label
                        label="Description"
                        className="text-labelTextCol !text-[14px] !font-aeonikBold"
                    />
                    <div className="!mb-3">
                        <p className="text-[14.5px] !font-aeonikMed break-words"
                            dangerouslySetInnerHTML={{ __html: description }}
                        ></p>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default GroupSpotlightPreview;